import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=6b08ff82&"
import script from "./Pricing.vue?vue&type=script&lang=ts&"
export * from "./Pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports